import React, { ChangeEvent, useState, useEffect } from "react";
import axios from "axios";
import { Door } from "./types";

interface LockType {
  id: number;
  type_code: string;
  name: string;
  icon_path: string | null;
  display_order: number;
  is_active: number | boolean;
}

interface DoorTableProps {
  doors: Door[];
  handleRemoveDoorx: (id: number) => void;
  handleDoorChange: (index: number, field: keyof Door, value: string | number) => void;
  handleInputChange: (
    index: number,
    field: keyof Door,
    value: string | number,
    numb: number,
    step: number,
    name: string,
    innen: number,
    auben: number
  ) => void;
  getDefaultLockValues: (lockType: string) => { lockOutside: number; lockInside: number };
  backendUrl: string;
}

const DoorTable: React.FC<DoorTableProps> = ({
  doors,
  handleRemoveDoorx,
  handleDoorChange,
  handleInputChange,
  getDefaultLockValues,
  backendUrl,
}) => {
  const [lockTypes, setLockTypes] = useState<LockType[]>([]);

  useEffect(() => {
    const fetchLockTypes = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/v1/configurator/lock-types`);
        // Filtruj tylko aktywne typy i posortuj po display_order
        const activeLockTypes = response.data
          .filter((lt: LockType) => lt.is_active)
          .sort((a: LockType, b: LockType) => a.display_order - b.display_order);
        setLockTypes(activeLockTypes);
      } catch (error) {
        console.error("Error fetching lock types:", error);
      }
    };
    fetchLockTypes();
  }, [backendUrl]);

  return (
    <div className="door-table">
      {doors.map((el, index) => (
        <div key={index} className="door-table-row">
        <div className="door-name-wrapper" style={{ display: "flex", alignItems: "center",marginLeft: "1%", maxWidth: "26%", justifyContent: "flex-start"}}>
          <img
            src={`${backendUrl}/img/XRed.svg`}
            alt="X"
            style={{
              width: "20px",
              height: "20px",
              cursor: "pointer",
              padding: "4px",
              marginInline: "1%",
            }}
            onClick={() => handleRemoveDoorx(Number(el.id))}
          />
          <input
            type="text"
            placeholder="Name"
            value={el.doorName}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              handleDoorChange(index, "doorName", e.target.value)
            }
          />  </div>
          <input
           type="number"
  placeholder=""
  className="inputCenter lock-amount-input"
  value={el.lockAmount}
  onChange={(e: ChangeEvent<HTMLInputElement>) =>
    handleDoorChange(
      index,
      "lockAmount",
      parseInt(e.target.value, 10)
    )
  }
          />
          <div
            style={{
              display: "flex",
              width: "25%",
              textAlign: "center",
              justifyContent: "flex-start",
            }}
          >
            <img src={`${backendUrl}${lockTypes.find(lt => lt.type_code === el.lockType)?.icon_path || `/img/Types/${encodeURIComponent(el.lockType)}.png`}`} alt={el.lockType} style={{ width: "20px", height: "auto" }}></img>
            <select
              style={{
                width: "145px",
                border: "none",
                backgroundColor: "#F3F3F3",
                borderBottom: "#B1B1C5 solid 1px",
              }}
              value={el.lockType}
              onChange={(e) =>
                handleDoorChange(index, "lockType", e.target.value)
              }
            >
              {lockTypes.map((lockType) => (
                <option key={lockType.id} value={lockType.type_code}>
                  {lockType.name}
                </option>
              ))}
            </select>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-elevenly",
              width: "24%",
                marginLeft: "1%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "45%",
              }}
            >
              <div className="inputValueChangerForm">
                <div
                  onClick={() =>
                    handleInputChange(
                      index,
                      "lockOutside",
                      "",
                      el.lockOutside,
                      -5,
                      el.lockType,
                      el.lockInside,
                      el.lockOutside
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/minus.svg`}
                    alt="minus"
                    style={{ width: "12px" }}
                  />
                </div>
              </div>
              <input
                style={{
                  width: "30px",
                  border: "none",
                  backgroundColor: "#F3F3F3",
                  borderBottom: "#B1B1C5 solid 1px",
                  textAlign: "center",
                }}
                type="number"
                readOnly={true}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleDoorChange(
                    index,
                    "lockOutside",
                    parseInt(e.target.value, 10)
                  )
                }
                className="inputCenter"
                value={el.lockOutside === 0 ? "" : el.lockOutside.toString()}
                placeholder={
                  getDefaultLockValues(el.lockType).lockOutside?.toString() || ""
                }
                disabled={
                  el.lockType === "VHS" || el.lockType === "Briefkastenzylinder"
                    ? true
                    : false
                }
              />
              <div className="inputValueChangerForm">
                <div
                  onClick={() =>
                    handleInputChange(
                      index,
                      "lockOutside",
                      "",
                      el.lockOutside,
                      5,
                      el.lockType,
                      el.lockInside,
                      el.lockOutside
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/plus.svg`}
                    alt="minus"
                    style={{ width: "12px" }}
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                width: "45%",
              }}
            >
              <div className="inputValueChangerForm">
                <div
                  onClick={() =>
                    handleInputChange(
                      index,
                      "lockInside",
                      "",
                      el.lockInside,
                      -5,
                      el.lockType,
                      el.lockInside,
                      el.lockOutside
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/minus.svg`}
                    alt="minus"
                    style={{ width: "12px" }}
                  />
                </div>
              </div>
              <input
                style={{
                  width: "30px",
                  border: "none",
                  backgroundColor: "#F3F3F3",
                  borderBottom: "#B1B1C5 solid 1px",
                  textAlign: "center",
                }}
                type="number"
                readOnly={true}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleDoorChange(
                    index,
                    "lockInside",
                    parseInt(e.target.value, 10)
                  )
                }
                className="inputCenter"
                value={el.lockInside === 0 ? "" : el.lockInside.toString()}
                placeholder={
                  getDefaultLockValues(el.lockType).lockInside?.toString() || ""
                }
                disabled={
                  el.lockType === "HPZ" ||
                  el.lockType === "VHS" ||
                  el.lockType === "Briefkastenzylinder"
                    ? true
                    : false
                }
              />
              <div className="inputValueChangerForm">
                <div
                  onClick={() =>
                    handleInputChange(
                      index,
                      "lockInside",
                      "",
                      el.lockInside,
                      5,
                      el.lockType,
                      el.lockInside,
                      el.lockOutside
                    )
                  }
                >
                  <img
                    src={`${backendUrl}/img/configurator/plus.svg`}
                    alt="minus"
                    style={{ width: "12px" }}
                  />
                </div>
              </div>
            </div>
          </div>
           <div className="door" style={{ display: "flex", width: "42px",}}></div>
        </div>
      ))}
    </div>
  );
};

export default DoorTable;
